import { Info } from "lucide-react";

export const NoticeBar = () => (
  <div
    data-testid="bulgarche-notice"
    className="border-b border-brand-accent/20 bg-brand-accent/10"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-6 py-4 lg:px-8">
      <Info className="h-4 w-4 shrink-0 text-brand-accent" aria-hidden="true" />
      <p className="text-center text-xs font-medium leading-relaxed text-brand-dark md:text-sm">
        Всички предложения са допълнение към храната, включена в пакетите на
        Детски парти клуб „Българче“.
      </p>
    </div>
  </div>
);
